import React from 'react'
import { useEffect } from 'react';
import { useState } from "react";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useUpdateGstHsnCodeMutation, useGetGstHsnCodeDetailQuery } from '../../../../store/api/gsthsn';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Attachment from '../../../../utils/Attachment';
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
function Gsthsn() {
    const navigate = useNavigate()
    const location = useLocation()
    const gsthsnId = location?.state.taxId
    const [selectedtaxes, setSelectedtaxes] = useState([])
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [updateGstHsnCode] = useUpdateGstHsnCodeMutation();
    const { data: gstDetail } = useGetGstHsnCodeDetailQuery(gsthsnId);
     const pageStateDefault = {
            tab: 1,
            hsncode: "",
            description: "",
            taxes:[{  item_tax_template: "",
            tax_category: "",
            valid_from: "",
            minimum_net_rate: "",
            maximum_net_rate: "" }],
        
          };
        
          const [pageState, setPageState] = usePageState(`Edit GST HSN Code - ${gsthsnId}`, pageStateDefault);
        
        
          const { tab, hsncode, description, taxes } = pageState;

    useEffect(() => {
         if (!isStateChanged(pageState, pageStateDefault)) {
        if (gstDetail?.data) {
            const { hsn_code, description, taxes } = gstDetail.data
            setPageState({
                hsncode: hsn_code || "",
                description: description || "",
                taxes: taxes || ""
            })
        }
    }
    }, [gstDetail])

    const handleSubmit = async () => {

        const payload = { hsn_code: pageState.hsncode, description: pageState.description, taxes: taxes };
        try {
            const res = await updateGstHsnCode({ id: gsthsnId, body: payload });
            setError('GST HSN Code updated successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/gsthsncode/gst-hsn-list')
            }, 3000);
        } catch (error) {
            const parsedMessages = JSON.parse(error.data._server_messages);
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setptype('Error');
            setptype('Error');
            setShowError(true);
        }
    };
    return (
        <>
            <FormLayoutTwo
                title="Edit GST HSN Code"
                breadcrumbs={[
                    { label: "GST HSN Code" },
                    { label: "GST HSN Code List", url: "/master/gsthsncode/gst-hsn-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>

                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >Update
                        </Button>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { setPageState({ ...pageState, tab: 1 })  }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                            {/* <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                                <span style={{ position: 'relative', top: '-1px' }}>
                                    <GetIcon iconName="CgAttachment" size={12} />
                                </span>
                                <span className=" fw-semibold" style={{ color: "#391F84" }}>
                                    Attachments
                                </span>
                            </div> */}
                         <Attachment doctype="GST HSN Code"  docname={gsthsnId}  />    
                        </div>
                    </div>

                      <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
                  <Tab1  
                                                           
                                                           pageState={pageState}
                                                                  setPageState={setPageState}
                                handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                  onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                    taxes={{
                                  value: pageState.taxes || [],
                                  setValue: (val) =>
                                    setPageState({
                                      ...pageState,
                                      taxes: val,
                                    }),
                                }}
                                gsthsnId={gsthsnId}   />

              </div>
            </div>
          </div>
        </div>        
                   
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Gsthsn
